// extracted by mini-css-extract-plugin
export default {"wrapper":"CoursesList_wrapper__TFoo2"};